import axios from "axios";
import { supabase } from "../supabaseClient";

// CRM 2.0 CF NOC (M10): Banking › CF NOC. Backend routes/crm2Cf.js checks the
// Banking › CF NOC permissions (View / Download / Upload) and every field.
const base = () => `${process.env.REACT_APP_PAYMENT_LINK_URL}crm2/cf`;
const auth = () => ({ headers: { Authorization: `Bearer ${supabase.auth.session()?.access_token}` } });
const data = (response) => response.data.data;

// Returns { tab, counts: { new, sent, received }, rows, options: { projects, wings, lenders } }
async function getCfList(params) {
  return data(await axios.get(`${base()}/list`, { ...auth(), params }));
}

// Saves the file the server sends (xlsx or zip) and returns { sent, skipped }.
async function downloadFile(request) {
  const res = await request;
  const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || "CF NOC.xlsx";
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
  return { name, sent: Number(res.headers["x-cf-sent"]) || 0, skipped: Number(res.headers["x-cf-skipped"]) || 0 };
}

// Download CF Excel: the selected New requests move to Sent to lender.
async function exportCfExcel(ids) {
  return downloadFile(axios.post(`${base()}/export`, { ids }, { ...auth(), responseType: "blob" }));
}
async function redownloadCfExcel(batchId) {
  return downloadFile(axios.get(`${base()}/export/${batchId}`, { ...auth(), responseType: "blob" }));
}

async function undoCfSent(id, reason) {
  return data(await axios.post(`${base()}/${id}/undo-sent`, { reason }, auth()));
}
// body: { cfNumber, cfDate?, remarks?, fileName, fileBase64 } → { changed, emailed }
async function markCfReceived(id, body) {
  return data(await axios.post(`${base()}/${id}/received`, body, auth()));
}
async function undoCfReceived(id, reason) {
  return data(await axios.post(`${base()}/${id}/undo-received`, { reason }, auth()));
}
// Returns { url, name } — a 10-minute link to the CF NOC PDF
async function getCfDocument(id) {
  return data(await axios.get(`${base()}/${id}/document`, auth()));
}

// Super Admin: add a booking to the CF list by hand.
async function getCfProjects() {
  return data(await axios.get(`${base()}/bookings`, auth())).projects;
}
async function getCfBookings(projectId) {
  return data(await axios.get(`${base()}/bookings`, { ...auth(), params: { projectId } })).bookings;
}
async function requestCf(id, recheck) {
  return data(await axios.post(`${base()}/booking/${id}/request`, { recheck: !!recheck }, auth()));
}

// Error text and per-field messages (a file download's error comes back as a Blob).
async function cfError(err) {
  let body = err?.response?.data;
  if (body instanceof Blob) {
    try {
      body = JSON.parse(await body.text());
    } catch {
      body = {};
    }
  }
  return { message: body?.error || err?.message || "Something went wrong", fields: body?.fields || {} };
}

export {
  getCfList, exportCfExcel, redownloadCfExcel, undoCfSent, markCfReceived, undoCfReceived, getCfDocument,
  getCfProjects, getCfBookings, requestCf, cfError,
};
